import React, { useState } from "react";
import {
  Card,
  Progress,
  Button,
  Typography,
  Space,
  Collapse,
  Badge,
} from "antd";
import { MinusOutlined, UpOutlined, CloseOutlined } from "@ant-design/icons";
import { useProcess } from "src/components/ProgressPanel/index";
import "./process-panel.css";

const { Text } = Typography;
const { Panel } = Collapse;

const ProcessPanel = () => {
  const { processes, visible, closePanel } = useProcess();
  const [minimized, setMinimized] = useState(false);

  // 🔥 hanya proses aktif
  const runningProcesses = processes.filter((p) => p.status === "active");

  // 🔥 panel hanya muncul kalau ada proses aktif
  if (!visible || runningProcesses.length === 0) return null;

  return (
    <div className="process-panel">
      <Card
        size="small"
        title={
          <Space>
            <Text strong>Processes</Text>
            <Badge count={runningProcesses.length} />
          </Space>
        }
        extra={
          <Space>
            <Button
              type="text"
              size="small"
              icon={minimized ? <UpOutlined /> : <MinusOutlined />}
              onClick={() => setMinimized(!minimized)}
            />
            <Button
              type="text"
              size="small"
              icon={<CloseOutlined />}
              onClick={closePanel}
            />
          </Space>
        }
        bodyStyle={{ display: minimized ? "none" : "block" }}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          {runningProcesses.map((process) => (
            <Card
              key={process.id}
              size="small"
              type="inner"
              title={process.title}
            >
              <Progress percent={process.percent} status={process.status} />

              {process.steps?.length > 0 && (
                <Collapse ghost>
                  <Panel header="Steps" key="steps">
                    <Space direction="vertical">
                      {process.steps.map((step, idx) => (
                        <Text
                          key={idx}
                          type={step.done ? "success" : "secondary"}
                        >
                          {step.done ? "✔" : "•"} {step.label}
                        </Text>
                      ))}
                    </Space>
                  </Panel>
                </Collapse>
              )}
            </Card>
          ))}
        </Space>
      </Card>
    </div>
  );
};

export default ProcessPanel;
